import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import Form from "./Form";
import {UsePost, UsePut} from "../../hooks/http";
import {useNavigate} from "react-router-dom";
import {UseMessage} from "../../hooks/UseMessage";

const Create = () => {
    const navigate = useNavigate()
    const [errors, setErrors] = useState()
    const [roles, setRoles] = useState([])
    const [accounts, setAccounts] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    const handleCreate = (PostData) => {
        setIsLoading(true)
        UsePost(
            '/users/upsert/',
            {data: PostData}
        ).then((response) => {
            if (response.code >= 200 && response.code <= 299) {
                navigate(`/users/${response.id}`)
                UseMessage('success', 'User has been successfully created')
            } else {
                setErrors(response.errors) 
            }
            setIsLoading(false)
        })
    }


    const GetEntities = async () => {
        return {
            roles: await UsePut(
                `/roles/get`,
                {data: {offset: 0}, toArray: true, propLabel: 'name'}
            ),
            accounts: await UsePut(
                `/accounts/get`,
                {data: {offset: 0}, toArray: true, propLabel: 'name'}
            )
        }
    }


    useEffect(() => {
        GetEntities().then((response) => {
            setRoles(response.roles)
            setAccounts(response.accounts)
            setIsLoading(false)
        })
    }, [])

    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form roles={roles} accounts={accounts} isReady={!isLoading} errors={errors} onSubmit={handleCreate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Create